export const getListingFlowSteps = (isRelist) => {
  const submitButton = isRelist ? 'Re-list Now' : 'Submit Listing';

  return [
    `Click on the ${submitButton} button.`,
    'Check your inbox.',
    'Initial and sign the Listing Agreement. If there are other titleholders on the listing, the Agreement will be emailed to them after you have signed it.',
    'Once all owners have signed the Agreement your listing will be submitted to the Bōde Team for review and approval.',
    'It typically takes 2 business days for your listing to go live.',
  ];
};

export default {
  getListingFlowSteps,
};
